var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"quantEmbarques"}},[_c('loading',{attrs:{"color":"#2185d0","active":_vm.isLoading,"loader":"bars","is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('grafico-barra',{attrs:{"chart-data":_vm.dados_grafico,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }